import { create } from "zustand";

interface KycStoreState {
  acceptedRainTerms: boolean;
  isKycModalOpen: boolean;
  isSumsubProfileVerified: boolean;
  setAcceptedRainTerms: (accepted: boolean) => void;
  setKycModalOpen: (open: boolean) => void;
  setIsSumsubProfileVerified: (verified: boolean) => void;
}

export const useKycStore = create<KycStoreState>((set) => ({
  acceptedRainTerms: false,
  isKycModalOpen: false,
  isSumsubProfileVerified: false,
  setAcceptedRainTerms: (accepted) => set({ acceptedRainTerms: accepted }),
  setKycModalOpen: (open) => set({ isKycModalOpen: open }),
  setIsSumsubProfileVerified: (verified) =>
    set({ isSumsubProfileVerified: verified }),
}));
